import React from "react";
import { PortableText } from "@portabletext/react";

const BR_TAG_PATTERN = /<br\s*\/?>/gi;
const ESCAPED_BR_PATTERN = /&lt;br\s*\/?&gt;/gi;

const portableTextMarks = {
  strong: ({ children }) => <strong className="font-bold">{children}</strong>,
  em: ({ children }) => <em className="italic">{children}</em>,
};

const normalizeCellHtml = (text) =>
  text.replace(ESCAPED_BR_PATTERN, "<br>");

/** Render table cell text; <br> tags become real line breaks. */
const TableCellContent = ({ cell }) => {
  if (cell == null || cell === "") return null;

  if (Array.isArray(cell)) {
    return <PortableText value={cell} components={{ marks: portableTextMarks }} />;
  }

  const text = normalizeCellHtml(String(cell));

  if (!BR_TAG_PATTERN.test(text)) {
    return text;
  }

  BR_TAG_PATTERN.lastIndex = 0;
  const parts = text.split(BR_TAG_PATTERN);

  return parts.map((part, index) => (
    <React.Fragment key={index}>
      {index > 0 && <br />}
      {part}
    </React.Fragment>
  ));
};

const SanityTable = ({ value }) => {
  const rows = value?.rows ?? [];
  if (rows.length === 0) return null;

  const [headerRow, ...bodyRows] = rows;

  return (
    <div className="table-responsive my-3">
      <table className="table table-bordered">
        {headerRow?.cells?.length > 0 && (
          <thead>
            <tr>
              {headerRow.cells.map((cell, j) => (
                <th key={j} scope="col">
                  <TableCellContent cell={cell} />
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {bodyRows.map((row, i) => (
            <tr key={row._key ?? i}>
              {row?.cells?.map((cell, j) => (
                <td key={j}>
                  <TableCellContent cell={cell} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const sanityPortableTextComponents = {
  marks: portableTextMarks,
  types: {
    table: SanityTable,
  },
};
